export const priceChangeData = () => {
  var priceChanges = {}

  var columns = [
    {
      Header: 'Barcode',
      accessor: 'barcode'
    },
    {
      Header: 'PriceBefore',
      accessor: 'priceBefore'
    },
    {
      Header: 'PriceAfter',
      accessor: 'priceAfter'
    }
  ]

  var data = generatePriceChange(5)

  priceChanges.columns = columns
  priceChanges.data = data

  return priceChanges
}

const generatePriceChange = (num) => {
  const priceChanges = []

  for (let i = 0; i < num; ++i) {
    priceChanges.push({
      barcode: '12345678',
      priceBefore: Math.floor(Math.random() * 50) + 1,
      priceAfter: Math.floor(Math.random() * 50) + 1
    })
  }

  return priceChanges
}
